import { render, staticRenderFns } from "./tz-nsa-products-modal.vue?vue&type=template&id=27f50ba9&"
import script from "./tz-nsa-products-modal.vue?vue&type=script&lang=tsx&"
export * from "./tz-nsa-products-modal.vue?vue&type=script&lang=tsx&"
import style0 from "./tz-nsa-products-modal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports